import React from "react";
import BuildContainer from "../Common/BuildLogs/BuildContainer";

const TestPlanBuildLogs = ({ buildId }) => {
  return <BuildContainer buildType="testPlan" buildId={buildId} />;
};

export default TestPlanBuildLogs;
